import headerLinksStyle from "../../../material-kit-pro-react/components/headerLinksStyle.jsx";
import imagesStyles from "../../../material-kit-pro-react/imagesStyles";

import {
    container,
    mrAuto,
    mlAuto,
    title,
    successColor,
    dashed
} from "../../../material-kit-pro-react.jsx";

const headersSection = theme => ({
    ...headerLinksStyle(theme),
    sectionBlank: {
        height: "70px",
        display: "block"
    },
    container: {
        ...container,
        zIndex: "2",
        position: "relative",
        "& h1, & h4, & h6": {
            color: "#FFFFFF"
        }
    },
    conatinerHeader2: {
        ...container,
        zIndex: "2",
        position: "relative",
        "& h1, & h4, & h6": {
            color: "#FFFFFF"
        },
        paddingTop: "15vh"
    },
    title,
    titleLandingMobile: {
        ...title,
        marginTop: "40px",
        color: "#FFFFFF"
    },
    pageHeader: {
        position: "relative",
        height: "100vh",
        maxHeight: "1600px",
        backgroundPosition: "50%",
        backgroundSize: "cover",
        margin: "0",
        padding: "0",
        border: "0",
        display: "flex",
        WebkitBoxAlign: "center",
        MsFlexAlign: "center",
        alignItems: "center",
        "&:before": {
            background: "rgba(0, 0, 0, 0)"
        },
        "&:after,&:before": {
            position: "absolute",
            zIndex: "1",
            width: "100%",
            height: "100%",
            display: "block",
            left: "0",
            top: "0",
            content: "''"
        }
    },
    iframeContainer: {
        "& > iframe": {
            width: "100%",
            boxShadow:
                "0 16px 38px -12px rgba(0, 0, 0, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
        }
    },
    mrAuto,
    mlAuto,
    textCenter: {
        textAlign: "center"
    },
    card: {
        marginTop: "60px"
    },
    // formControl: {
    //     margin: "0",
    //     padding: "8px 0 0 0"
    // },
    formControl: {
        margin: "0",
        paddingTop: "0 !important",
        position: "relative",
        "& svg,& .fab,& .far,& .fal,& .fas,& .material-icons": {
            color: "#495057"
        }
    },
    textRight: {
        textAlign: "right"
    },
    checkboxAndRadio: {
        position: "relative",
        display: "block",
        marginTop: "10px"
    },
    checkboxAndRadioHorizontal: {
        position: "relative",
        display: "block",
        "&:first-child": {
            marginTop: "18px"
        },
        "&:not(:first-child)": {
            marginTop: "14px"
        }
    },
    checked: {
        color: successColor + "!important"
    },
    checkedIcon: {
        width: "20px",
        height: "20px",
        border: "1px solid rgba(0, 0, 0, 0.84)",
        borderRadius: "3px"
    },
    uncheckedIcon: {
        width: "0px",
        height: "0px",
        padding: "9px",
        border: "1px solid rgba(0, 0, 0, .54)",
        borderRadius: "3px"
    },
    label: {
        cursor: "pointer",
        paddingLeft: "0",
        color: "#555555", // dancard "#AAAAAA",
        fontSize: "14px",
        lineHeight: "1.428571429",
        fontWeight: "400",
        display: "inline-flex",
        transition: "0.3s ease all"
    },

    dashed,
    compressedInput: {
        margin: "0",
        paddingTop: "0",
        "& input": {
            color: "white"
        }
    },
    compressedInput2: {
        margin: "0",
        paddingTop: "3px"
    },
    compressedInput3: {
        margin: "0",
        color: "#555",
        paddingTop: "9px !important"
    },
    errorDisplay: {
        color: "red"
    },
    compressedHeader: {
        padding: "0.5rem 15px"
    },
    hiddenInMobile: {
        "@media (max-width: 700px)": {
            display: "none"
        }
    },
    hiddenInDesktop: {
        "@media (min-width: 700px)": {
            display: "none"
        }
    },
    metasearch: {
        background: "none",
        "@media (min-width: 700px)": { // Show in desktop
            marginTop: "60px",
            marginBottom: "-39px"
        },
        "@media (max-width: 700px)": { // Show in mobile
            marginTop: "15px"
        }
    },
    inputWhite: {
        backgroundColor: "#fff",
        color: "#555",
        "@media (min-width: 700px)": { // Show in desktop
            borderRadius: "3px"
        },
        padding: "5px",
        height: "47px",
        "& input": {
            backgroundImage: "none !important"
        },
        "& div:before": {
            borderBottom: "none"
        }
    },
    inputWhite2: {
        "& span": {
            color: "#fff"
        },
        "& input": {
            color: "#fff"
        }
    },
    checkedIconWhite: {
        width: "20px",
        height: "20px",
        border: "1px solid #fff",
        borderRadius: "3px"
    },
    uncheckedIconWhite: {
        width: "0px",
        height: "0px",
        padding: "9px",
        border: "1px solid #fff",
        borderRadius: "3px"
    },
    inputContainersMetaS1: {
        "@media (min-width: 700px)": { // Show in desktop
            paddingRight: "7px"
        }
    },
    inputContainersMetaS2: {
        "@media (min-width: 700px)": { // Show in desktop
            paddingLeft: "7px",
            paddingRight: "7px"
        }
    },
    inputContainersMetaS3: {
        "@media (min-width: 700px)": { // Show in desktop
            paddingLeft: "7px"
        }
    },


    vecShadowTitle: {
        "@media (min-width: 700px)": { // Show in desktop
            textShadow: "black 6px 4px"
        },
        "@media (max-width: 700px)": { // Show in mobile
            textShadow: "black 2px 2px"
        }

    },
    vecShadowSubtitle: {
        textShadow: "black 2px 2px"
    },
    modalRoot: {
        overflow: "auto",
        display: "block"
    },
    modalHeader: {
        borderBottom: "none",
        paddingTop: "24px",
        paddingRight: "24px",
        paddingBottom: "0",
        paddingLeft: "24px",
        minHeight: "16.43px"
    },
    modalCloseButton: {
        "&, &:hover": {
            color: "#999999"
        },
        "&:hover": {
            opacity: "1"
        },
        cursor: "pointer",
        padding: "1rem",
        margin: "-1rem -1rem -1rem auto",
        backgroundColor: "transparent",
        border: "0",
        WebkitAppearance: "none",
        float: "right",
        fontSize: "1.5rem",
        fontWeight: "500",
        lineHeight: "1",
        textShadow: "0 1px 0 #ffffff",
        opacity: ".5"
    },
    modalClose: {
        width: "16px",
        height: "16px"
    },
    modalTitle: {
        margin: "0",
        lineHeight: "1.5"
    },
    modalTitle2: {
        marginTop: "0"
    },
    modalBody: {
        paddingTop: "24px",
        paddingRight: "24px",
        paddingBottom: "16px",
        paddingLeft: "24px",
        position: "relative",
        overflow: "visible"
    },
    listedIcon: {
        fontSize: "18px",
        color: "green"
    },
    routesModalDescription: {
        margin: "1px"
    },
    modalChristmas: {
        maxWidth: "800px",
        margin: "1.75rem auto",
        borderRadius: "6px",
        overflow: "visible",
        maxHeight: "unset",
        width: "100%",
        marginTop: "130px !important"
    },
    ...imagesStyles,
    shadow: {
        backgroundColor: "#0000008f",
        borderRadius: "5px"
    },
    containerShadow: {
        backgroundColor: "#95ba719e",
        borderRadius: "7px"
    },
    pageHeader2: {
        "@media (min-width: 700px)": {
            backgroundSize: "contain",
            backgroundRepeat: "round",
            backgroundPosition: "0"
        }
    }
});

export default headersSection;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-pro-react/views/sectionsSections/headersStyle.jsx